<template>
    <div ref="findHeight">
        <NavigationView />
        <BannerView />
        <who-view />
        <div v-if="scrolled">
            <RankingRecongnition />
            <DegreeView />
            <!--itsalladdup-->
            <section class="mt-7">
                <div class="bg-gradient-to-b from-[#0F3E9D] to-[#081B59] min-h-[500px] py-1">
                    <div class="mt-[2rem] md:mt-[4rem] mb-[2rem] md:mb-[4rem] max-w-7xl 2xl:max-w-screen-2xl m-auto">
                        <div
                            class="flex flex-col items-center lg:flex-row md:gap-5 xl:gap-x-[1rem] lg:justify-around md:rounded-b-2xl">
                            <div class="flex flex-col items-center relative">
                                <h2 class="text-[#F8C300] text-2xl font-semibold md:text-3xl">How Are We Different</h2>
                                <h2 class="w-[15rem] text-center text-md text-white pb-[1rem] md:w-max font-bold">
                                    Providing a holistic
                                    learning experience to learners worldwide.</h2>
                                <div class="flex gap-4 cursor-pointer">
                                    <div v-for="tab in tabs" :key="tab" @click="(active = tab), (end_val = 4)" :class="{
                                            'text-[#F8C300]': active === tab,
                                            'text-white': active !== tab,
                                        }">
                                        <h2 class="mb-5">{{ tab }}</h2>
                                    </div>
                                </div>
                                <div v-if="active === 'Experiential Metrics'">
                                    <div class="flex flex-col items-center w-full">
                                        <div v-for="(item, index) in accordinItem" :key="index"
                                            class="flex flex-col text-left gap-2 w-[23rem] md:w-[40rem] shadow-xl bg-[#0F3E9D] mb-[10px] rounded-lg">
                                            <div class="flex justify-around items-center gap-1 cursor-pointer"
                                                @click="toggleAccordin(index)">
                                                <ul class="text-md p-[1rem] w-[15rem] md:w-[36rem]" :class="activeAccordin === index
                                                    ? 'text-[#F8C300]'
                                                    : 'text-white'
                                                    ">
                                                    <li class="list-disc">{{ item.title }}</li>
                                                </ul>

                                                <div v-if="this.activeAccordin !== index" class="pt-[3px] pl-[4px]">
                                                    <img src="@/assets/nav/down.svg"
                                                        class="w-[14px] h-[16px] object-contain" alt="down arrow" />
                                                </div>
                                                <div v-else class="pt-[3px] pl-[4px]">
                                                    <img src="@/assets/nav/up_yellow.svg"
                                                        class="w-[14px] h-[16px] object-contain" alt="up arrow" />
                                                </div>
                                            </div>

                                            <p class="text-sm text-white w-[18rem] md:w-[37rem] text-start m-auto pb-2"
                                                v-show="activeAccordin === index" v-html="item.content"></p>
                                        </div>
                                        <div class="bg-gradient-to-b from-[#0F2377] to-[#081B59] h-[30px]"></div>
                                    </div>
                                </div>
                                <div v-if="active === 'Quantitative metrics'">
                                    <div class="flex flex-col items-center w-full">
                                        <div v-for="(item, index) in quantitativeItem" :key="index"
                                            class="flex flex-col text-left gap-2 w-[23rem] md:w-[40rem] shadow-xl bg-[#0F3E9D] mb-[10px] rounded-lg">
                                            <div class="flex justify-around items-center gap-1 cursor-pointer"
                                                @click="toggleAccordin(index)">
                                                <ul class="text-md p-[1rem] w-[15rem] md:w-[36rem]" :class="activeAccordin === index
                                                    ? 'text-[#F8C300]'
                                                    : 'text-white'
                                                    ">
                                                    <li class="list-disc">{{ item.title }}</li>
                                                </ul>
                                                <div v-if="this.activeAccordin !== index" class="pt-[3px] pl-[4px]">
                                                    <img src="@/assets/nav/down.svg"
                                                        class="w-[14px] h-[16px] object-contain" alt="down arrow" />
                                                </div>
                                                <div v-else class="pt-[3px] pl-[4px]">
                                                    <img src="@/assets/nav/up_yellow.svg"
                                                        class="w-[14px] h-[16px] object-contain" alt="up arrow" />
                                                </div>
                                            </div>
                                            <p class="text-sm text-white w-[18rem] md:w-[37rem] text-start m-auto pb-2"
                                                v-show="activeAccordin === index" v-html="item.content"></p>
                                        </div>
                                        <div class="bg-gradient-to-b from-[#0F2377] to-[#081B59] h-[30px]"></div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div class="text-white w-[13rem] m-auto font-bold lg:hidden mt-8 md:hidden">
                                    Thousands Choose JAIN Online Every Year
                                </div>
                                <picture class="object-contain">
                                    <source media="(min-width:650px)" srcset="@/assets/home/Website-banner.webp"
                                        alt="why choose jain online" />
                                    <img src="@/assets/home/Website-banner-(1).webp" alt="why choose jain online"
                                        class="w-[390px] h-[480px] object-contain lg:w-[520px] lg:h-[627px] lg:ml-4 xl:ml-0"
                                        loading="lazy" decoding="async" />
                                </picture>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!--itsalladdup-->
            <ApproachView />
            <EngageView />
            <!-- <UpComing /> -->
            <AluminaiView />
            <HiringCompanies />
            <DreamsView />
            <TrendingView />
            <OurBlogs />
            <!--  Faq -->
            <ElectiveFaq faq="home" />
            <!--  Faq -->
            <FooterView />
            <!-- <ChatView /> -->
        </div>
        <SocialHome />
    </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import NavigationView from "@/components/NavigationView.vue";
import BannerView from "@/components/Home/BannerView.vue";
import WhoView from "@/components/Home/WhoView.vue";
const RankingRecongnition = defineAsyncComponent(() =>
    import(
    /* webpackChunkName: "ranking" */ "@/components/Home/RankingRecongnition.vue"
    )
);
const DegreeView = defineAsyncComponent(() =>
    import(/* webpackChunkName: "degree" */ "@/components/Home/DegreeView.vue")
);
const ApproachView = defineAsyncComponent(() =>
    import(
    /* webpackChunkName: "approach" */ "@/components/Home/ApproachView.vue"
    )
);
const EngageView = defineAsyncComponent(() =>
    import(/* webpackChunkName: "engage" */ "@/components/Home/EngageView.vue")
);
const FooterView = defineAsyncComponent(() =>
    import(/* webpackChunkName: "footer" */ "@/components/Home/FooterView.vue")
);
//const UpComing = defineAsyncComponent(() =>
//    import(/* webpackChunkName: "upcoming" */ "@/components/Home/UpComing.vue")
//);
const AluminaiView = defineAsyncComponent(() =>
    import(
    /* webpackChunkName: "aluminai" */ "@/components/Home/AluminaiView.vue"
    )
);
const HiringCompanies = defineAsyncComponent(() =>
    import(
    /* webpackChunkName: "hiring" */ "@/components/Home/HiringCompanies.vue"
    )
);
const DreamsView = defineAsyncComponent(() =>
    import(/* webpackChunkName: "dream" */ "@/components/Home/DreamsView.vue")
);
const TrendingView = defineAsyncComponent(() =>
    import(
    /* webpackChunkName: "trending" */ "@/components/Home/TrendingView.vue"
    )
);
const OurBlogs = defineAsyncComponent(() =>
    import(/* webpackChunkName: "blogs" */ "@/components/Home/OurBlogs.vue")
);
// const SocialHome = defineAsyncComponent(() =>
//     import(/* webpackChunkName: "social" */ "@/components/SocialHome.vue")
// );
import SocialHome from "@/components/SocialHome.vue";

// const ChatView = defineAsyncComponent(() =>
//     import(/* webpackChunkName: "chatbox" */ "@/components/ChatView.vue")
// );
const ElectiveFaq = defineAsyncComponent(() =>
    import(
    /* webpackChunkName: "elective" */ "@/components/ElectiveListing/ElectiveFaq.vue"
    )
);

export default {
    name: "HomveView",
    components: {
        NavigationView,
        BannerView,
        WhoView,
        RankingRecongnition,
        DegreeView,
        ApproachView,
        EngageView,
        //UpComing,
        AluminaiView,
        HiringCompanies,
        DreamsView,
        TrendingView,
        OurBlogs,
        SocialHome,
        ElectiveFaq,
        FooterView,
    },
    data() {
        return {
            // start_val: 0,
            // end_val: 4,
            activeAccordin: null,
            scrolled: false,
            tabs: ["Experiential Metrics", "Quantitative metrics"],
            active: "Experiential Metrics",
            accordinItem: [
                {
                    title: "Technology-enabled Learning and Assessments",
                    content:
                        "Elevate your learning by blending cutting-edge technology with interactive learning methodology.</p><br><ul><li>1. Flipbooks</li>2. Level 2 Interactive Learning Content<li>3. Learn by Doing Modules</li><li>4. Virtual Labs</li></ul>",
                },
                {
                    title: "Outcome Based Learning",
                    content:
                        "<p>Achieve real-world success through outcome-based learning, gaining practical skills that align with industry requirements.",
                },
                {
                    title: "Focus on Competencies",
                    content:
                        "Become more competent through an education system that goes beyond traditional university learning.",
                },
                {
                    title: "Practical Exposure",
                    content:
                        "Immerse yourself in experiential learning, bridging the gap between theoretical knowledge and real-world application.",
                },
                {
                    title: "Beyond-the-classroom Activities",
                    content:
                        "Embrace a holistic educational experience with co-curricular and extra-curricular activities, fostering creativity, leadership, and a sense of community.",
                },
            ],
            quantitativeItem: [
                {
                    title: "40+ Electives",
                    content:
                        "Explore a diverse range of in-demand electives tailored by industry experts for a dynamic learning experience.",
                },
                {
                    title: "2,400+ Hours of learning through LMS",
                    content:
                        " <ol><li>1. 2400+ Hours of Learning Through LMS</li><li></li>2. Dive deep into a comprehensive digital learning experience, maximizing educational engagement through flexible scheduling.</ol>",
                },
                {
                    title: "30+ Years of credibility",
                    content:
                        "<ol><li>1. 30+ Years of Credibility</li><li>2. Entrust us with the credibility we've built over three decades, a testament to our commitment to delivering quality educational services.</li></ol>",
                },
                {
                    title: "43+ Countries reached",
                    content:
                        "<ul><li>1. 43+ Countries Reached</li><li>2. Connect with learners from all over the world to cultivate a diverse and inclusive learning environment.</li></ul>",
                },
                {
                    title: "365 Days of ENGAGE",
                    content:
                        "Get an on-campus-like experience with ENGAGE - The Learner Community Space of JAIN Online ",
                },
            ],
            accordinShow: 5,
        };
    },
    async created() {
        await this.findHeight();
        await this.findViewPort();
    },

    methods: {
        toggleAccordin(index) {
            if (index === this.activeAccordin) {
                this.activeAccordin = null;
            } else {
                this.activeAccordin = index;
            }
        },
        async contentHeight() {
            await this.$nextTick();
            this.heightContent = this.$refs.findHeight.offsetHeight;
            return this.heightContent;
        },

        async findHeight() {
            const heightContent = await this.contentHeight();
            await this.findViewPort(heightContent);
        },

        async findViewPort(heightContent) {
            let height = window.innerHeight;
            if (height < heightContent) {
                document.addEventListener("scroll", () => {
                    if (window.scrollY > 50) {
                        this.mobileScrolled = true;
                        this.scrolled = true;
                    }
                });
            } else if (height >= heightContent) {
                this.scrolled = true;
            }
        },
    },
};
</script>
<style></style>
